import { AfterViewInit, Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { DetectBrowser, DETECT_BROWSER } from '@finder/shared/utils/browser/detect-browser';

@Directive({
    selector: '[finderAriaHidden]',
    standalone: true
})
export class AriaHiddenDirective implements AfterViewInit{
    private hideIf: string;

    @Input() set finderAriaHidden(val: string) {
        this.hideIf = val;
    }

    constructor(
        @Inject(DETECT_BROWSER) private detectBrowser: DetectBrowser,
        private el: ElementRef,
        private winRef: WindowRef,
        private renderer: Renderer2
    ) { }

    ngAfterViewInit(): void {
        this.hideElement();
    }

    getRenderer() {
        return this.renderer;
    }

    private hideElement() {
        switch(this.hideIf) {
            case 'safari':
                this.hideIfSafari();
                break;
            default:
                break;
        }
    }

    private hideIfSafari() {
        if (!this.detectBrowser(this.winRef, ['iPad', 'iPhone', 'WebKit'])) {
            return;
        }

        // Hide the element from screen readers
        this.getRenderer().setAttribute(this.el.nativeElement, 'aria-hidden', 'true');
    }
}
